<template>
  <div class="file">
    <div
      class="file-item"
      :class="{ operateType: operateLock, checked, uploading}"
      @contextmenu.prevent="contextmenu($event)"
      @click  ="handleClick"
    >
      <span class="checkbox-btn" :class="{ checked }" v-if="operateLock"></span>
      <div v-if="uploading" class="close-btn" @click.prevent="handleCancelUpload">
        <i class="icon iconfont iconicon_empty"></i>
      </div>
      <div
        class="file-content"
        v-loading="item.downloading"
        element-loading-text="下载中"
      >
        <img :src="imgUrl" alt="">
        <div class="file-name-wrap">
          <!-- <el-tooltip class="file-name" :content="fileName" placement="top" v-if="item.type === 2 && fileName.length > 8">
            <div>
              <span class="left">{{ fileName.substr(0, getHeadText(fileName)) }}</span>
              <span class="right">{{ fileName.substr(getHeadText(fileName)) }}</span>
            </div>
          </el-tooltip> -->
          <!-- <ToolTip
            class="file-name"
            :title="fileName"
            :maxWidth="'112px'"
          >
            {{ fileName }}
          </ToolTip> -->
          <div
            class="file-name"
            @mouseover="handleMouseover"
            @mouseleave="handleMouseleave"
            @mousemove="handleMousemove"
          >
            <p class="name" ref="name" :class="{ oversize : nameOversizeLock}">{{ fileName }}</p>
            <div class="tooltip-name" v-if="tooltipLock && nameOversizeLock" :style="{ left: nameLeft + 'px', top: nameTop + 'px' }">
              <p>{{ fileName }}</p>
            </div>
          </div>
          <!-- <div class="file-name" v-else-if="item.type === 2">
            <span class="left">{{ fileName.substr(0, getHeadText(fileName)) }}</span>
            <span class="right">{{ fileName.substr(getHeadText(fileName)) }}</span>
          </div> -->
          <!-- <div class="file-name" v-if="item.type === 2">
            <span class="left">{{ fileName.substr(0, getHeadText(fileName)) }}</span>
            <span>{{ fileName.substr(getHeadText(fileName)) }}</span>
          </div> -->
          <!-- <el-tooltip v-else-if="item.type === 1 && fileName.length >= 8" :content="fileName" placement="top">
            <p>{{ fileName }}</p>
          </el-tooltip>
          <p v-else>{{ fileName }}</p> -->
        </div>
      </div>

      <div class="progress-wrap" v-if="uploading">
        <el-progress :percentage="percentage" :show-text="false" :color="'#2682FF'"></el-progress>
      </div>
    </div>

    <ul class="operate-content" ref="operate-content" v-if="show" :style="{ left: left + 'px', top: top + 'px' }">
      <li v-if="item.type === 2" @click.stop="handleDown">
        <i class="icon iconfont iconicon_download"></i>
        下载
      </li>
      <li v-if="item.rename_permission" @click.stop="handleRename">
        <i class="icon iconfont iconicon_question_minutes"></i>
        重命名
      </li>
      <li v-if="item.move_permission" @click.stop="handleMove">
        <i class="icon iconfont iconicon_move"></i>
        移动
      </li>
      <li v-if="item.delete_permission" @click.stop="handleDelete" class="warn">
        <i class="icon iconfont iconicon_delete"></i>
        删除{{ fileCallName }}
      </li>
    </ul>

    <!-- 重命名弹窗 -->
    <el-dialog
      :title="fileCallName + '重命名'"
      :visible.sync="dialogVisible"
      :width="'422px'"
      :close-on-click-modal="false"
    >
      <el-input
        :class="{ renameErr }"
        type="textarea"
        maxlength="20"
        v-model="newFolderName"
        placeholder="请输入名称"
        :rows="3"
        @keydown.native="newFolderFnKeydown($event)"
      ></el-input>
      <div class="err" v-if="renameErr">
        <i class="icon iconfont icontishi"></i>
        与现有{{ fileCallName }}重名，请重新输入
      </div>
      <div class="btn-wrap" slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="newFolderFn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//api
import fileApi from '@/services/api/fileManagement'
import ToolTip from '@/components/toolTip'
export default {
  components: { ToolTip },
  props: {
    item: {
      type: [Array, Object],
      default: () => []
    },
    operateLock: {  // 是否进入批量操作状态
      type: Boolean,
      default: false
    },
    fileTreesId: {
      type: Number
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    uploading: {  // 是否上传中状态
      type: Boolean,
      default: false
    },
    percentage: { // 上传进度
      type: Number
    },
    projectFile: {  //  是否为项目文件
      type: Boolean,
      default: false
    }
  },
  computed: {
    fileName() {
      return this.uploading
              ? this.item.attachment_name
              : this.item.type === 1
                ? this.item.fileable.folder_name
                  ? this.item.fileable.folder_name
                  : this.item.fileable.title
                : this.item.fileable.attachment_name
    },
    fileCallName() {
      return this.item.type === 1 ? '文件夹' : '文件'
    },
    imgUrl() {
      let url = ''
      if (this.uploading) {
        const _type = this.item.name.slice(this.item.name.lastIndexOf('.') + 1)
        url = this.getImgUrl(_type)
      } else {
        if (this.item.type === 1) {
          //文件夹
          url = this.item.number_of_child_files ? 'image/file/img_folde.png' : 'image/file/img_empty_folde.png'
        } else {
          const type = this.item.fileable.attachment_type
          url = this.getImgUrl(type)
        }
      }

      return url
    }
  },
  watch: {
    // dialogVisible(val) {
    //   if (!val) {
    //     this.newFolderName = ''
    //   }
    // },
    selectAll(val) {
      this.checked = val
    },
    checked(val) {
      //批量操作操作时
      this.$emit('checked', this.item, val)
    },
    operateLock(val) {
      if (!val) {
        this.checked = false
      }
    },
    newFolderName(val) {
      if (this.renameErr) {
        if (val !== this.rename) {
          this.renameErr = false
        }
      }
    }
  },
  data() {
    return {
      left: 0,
      top: 0,
      show: false,
      tooltipLock: false,
      nameLeft: 0,
      nameTop: 0,
      nameOversizeLock: false,
      checked: false,
      dialogVisible: false,
      newFolderName: '',
      renameErr: false,  //重命名错误
      rename: ''
    }
  },
  mounted() {
    window.addEventListener('click', e => {
      this.clearBox(e)
    })
    window.addEventListener('mousedown', e => {
      if (e.button !== '0') {
        this.clearBox(e)
      }
    })

    this.nameOversizeFn()
  },
  updated() {
    this.nameOversizeFn()
  },
  methods: {
    contextmenu(e) {
        //批量操作时 或者  上传状态中 或者 为项目文件夹
      if (this.operateLock || this.uploading || this.projectFile) return

      //item为文件夹，并且无各种权限时
      if (this.item.type === 1 && !this.item.delete_permission && !this.item.move_permission && !this.item.rename_permission) return

      this.left = e.pageX + 20
      this.top = e.pageY + 20
      this.$nextTick(() => {
        this.show = true
      })
    },
    //关闭文件浮窗
    clearBox(e) {
      let box = this.$refs['operate-content']
      let fl = (e.path || e.composedPath()).find(res => res === box)
      if (!fl) {
        this.show = false
      }
    },
    //附件名称 超出省略号，保留后4个字符
    getHeadText(data) {
      const idx = data.lastIndexOf('.') - 4
      return idx < 1 ? data.lastIndexOf('.') : idx
    },
    getFileName(val) {
      const num = val.lastIndexOf('.')
      const idx = num >= 0 ? num : val.length
      return val.substr(0, idx)
    },
    nameOversizeFn() {
      // if (this.$refs.name.offsetWidth > 112) {
      //   // 如果文字宽度超出 变量为true 以此添加类名
      //   this.nameOversizeLock = true
      // }
      if (this.$refs.name.offsetHeight > 40) {
        // 如果文字宽度超出 变量为true 以此添加类名
        this.nameOversizeLock = true
      }
    },
    handleMouseover() {
      this.tooltipLock = true
      // console.log(this.$refs.name)
    },
    handleMouseleave() {
      this.tooltipLock = false
    },
    handleMousemove(e) {
      this.nameLeft = e.pageX + 20
      this.nameTop = e.pageY + 20
    },
    getImgUrl(type) {
      let url = ''
      switch(type) {
        case 'jpg':
        case 'png':
          url = 'image/file/pic.png'
          break
        case 'pdf':
          url = 'image/file/pdf.png'
          break
        case 'doc':
          url = 'image/file/doc.png'
          break
        case 'docx':
          url = 'image/file/docx.png'
          break
        case 'xls':
        case 'xlsx':
          url = 'image/file/execl.png'
          break
        case 'ppt':
        case 'pptx':
          url = 'image/file/ppt.png'
          break
        case 'mp4':
        case 'avi':
        case 'flv':
        case 'wav':
        case 'mov':
        case 'mpeg':
          url = 'image/file/video.png'
          break
        default:
          url = 'image/file/normal.png'
      }
      return url
    },
    //点击文件
    handleClick() {
      if (this.uploading) return  //上传状态中
      if (this.operateLock) {
        //批量操作时
        this.checked = !this.checked
        return
      }
      if (this.item.type === 1) {
        //为文件夹时
        // console.log(this.item)
        this.$emit('emitClickFolder', this.item.id, this.fileName, this.item.create_folder_permission)
      } else {
        const name = this.item.fileable.oss_attachment_name
        const _type = this.item.fileable.attachment_type
        const _arr = ['jpg', 'png', 'gif', 'jpeg', 'tiff', 'psd', 'raw', 'eps', 'svg', 'bmp', 'pdf', 'docx']
        const typeVideo = ['mp4', 'mpeg', 'mpg', 'dat', 'avi', 'mov', 'asf', 'wmv', 'navi', '3gp', 'mkv', 'flv', 'f4v', 'rmvb', 'webm', 'hddvd', 'qsv']
        const _arr2 = _arr.concat(typeVideo)
        if (_arr2.indexOf(_type) >= 0) {
          this.getOssUrl(name, (data) => {
            this.opendImgUrl(_type, data.sign_url)
          })
        } else {
          this.$message({
            message: '该文件不支持预览，请下载后查看',
            type: 'warning'
          })
        }
      }
    },
    //取消上传
    handleCancelUpload() {
      this.$emit('cancelUpload', this.item)
    },
    handleDown() {
      this.show = false
      this.$emit('download', [this.item.id])
    },
    //重命名
    handleRename() {
      this.show = false
      this.newFolderName = this.item.type === 1 ? this.fileName : this.getFileName(this.fileName)
      this.dialogVisible = true
    },
    //输入框回车键
    newFolderFnKeydown(event) {
      if (event.keyCode === 13) {
        this.newFolderFn()
        event.preventDefault() // 阻止浏览器默认换行操作
        return false
      }
    },
    async newFolderFn() {
      if (!this.newFolderName) return

      this.newFolderName = this.newFolderName.trim()

      const _name = this.item.type === 1 ? this.newFolderName : this.newFolderName + '.' + this.item.fileable.attachment_type

      try{
        const _data = {
          file_tree_id: this.item.id,
          rename_file_name: _name
        }
        const res = await fileApi.renameFile(_data)
        if (res) {
          this.dialogVisible = false
          this.$message({
            message: '重命名成功',
            type: 'success'
          })
          this.$emit('updateInit')
        }
      } catch(err) {
        if (err.message.indexOf('重名') >= 0) {
          this.rename = this.newFolderName
          this.renameErr = true
        } else {
          this.$message.error(err.message);
        }
      }
    },
    //移动
    handleMove() {
      this.show = false
      this.$emit('move', this.item.id)
    },
    //删除
    async handleDelete() {
      this.show = false
      // console.log(this.item.number_of_subfolders)
      // if (this.item.number_of_subfolders) {
      //   //内有文件，不可删除
      //   this.$message({
      //     message: '该文件夹不为空，不可删除',
      //     type: 'warning'
      //   });
      //   return
      // }
      this.$emit('delete', [{ id: this.item.id, type: this.item.type }])
    }
  }
}
</script>

<style lang="scss" scoped>
.file {
  .file-item {
    width: 134px;
    height: 132px;
    margin: 8px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;
    border: 1px solid rgba(0, 0, 0, 0);
    &:hover {
      background-color: #f7f8f9;
    }
    &:active {
      background-color: #ecedee;
    }
    .checkbox-btn {
      display: block;
      width: 16px;
      height: 16px;
      background: rgba(32, 32, 32, 0.08);
      border: 1px solid rgba(13, 31, 60, 0.4);
      box-sizing: border-box;
      position: absolute;
      top: 4px;
      right: 4px;
      border-radius: 50%;
      &.checked {
        border: none;
        background: url(~@/assets/images/icon_selected_files.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .close-btn {
      position: absolute;
      top: 4px;
      right: 4px;
      z-index: 9;
      cursor: pointer;
      .iconfont {
        color: #C3C6CB;
        &:hover {
          color: $color-active;
        }
        &:active {
          color: $colorStatus-activeColor;
        }
      }
    }
    &.operateType {
      border: 1px solid #ecedee;
      position: relative;
      &.checked {
        border: 1px solid $colorStatus-hoverColor;
        .file-content {
          opacity: .6;
        }
      }
      .el-checkbox  {
        position: absolute;
        top: 4px;
        right: 4px;
      }
    }
    &.uploading {
      border: 1px solid #ECEDEE;
      box-sizing: border-box;
      // &::after {
      //   content: '';
      //   display: block;
      //   width: 100%;
      //   height: 100%;
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   background: rgba(255, 255, 255, .5);
      // }
    }
    .file-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        display: block;
        width: 54px;
        height: 54px;
        margin-top: 24px;
      }
      .file-name-wrap {
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 14px;
        line-height: 1.3;
        font-weight: 400;
        margin-top: 10px;
        color: rgba(32, 32, 40, 0.8);
        width: 100%;
        display: flex;
        justify-content: center;
        .file-name {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          position: relative;
          .left {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
          }
          .right {
            flex-shrink: 0;
          }
          .name {
            // white-space:nowrap;
            text-align: center;
            word-break:break-all;
            &.oversize {
              // width: 100%;
              // overflow: hidden;
              // text-overflow: ellipsis;
              // white-space: nowrap;

              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
          .tooltip-name {
            position: fixed;
            background: rgba(13, 31, 60, .8);
            border-radius: 2px;
            box-shadow: 0px 2px 4px 0px rgba(117, 116, 142, 0.2);
            font-size: 12px;
            color: #FFFFFF;
            line-height: 14px;
            font-weight: 400;
            padding: 7px 16px;
            max-width: 300px;
            z-index: 100;
          }
        }
      }
    }
    .progress-wrap {
      position: absolute;
      bottom: 8px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 111px;
      height: 0;
    }
  }

  .operate-content {
    // position: absolute;
    width: 132px;
    background-color: #fff;
    box-shadow: 0px 2px 8px 0px rgba(218, 219, 224, 1);
    position: fixed;
    transition: all 0.3s;
    border-radius: 4px;
    z-index: 999;
    padding: 8px 0;
    li {
      height: 40px;
      padding-left: 16px;
      line-height: 40px;
      font-size: 14px;
      color: #3A4960;
      font-weight: 400;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover {
        background: rgba(32, 32, 32, 0.04);
      }
      &:active {
        background: #EAEBEC;
      }
      &.warn {
        color: #FF3939;
        &:hover,
        &:focus  {
          background: #FFF0F0;
        }
        &:active {
          background: #FFD8D8;
        }
      }
      .iconfont {
        font-size: 14px;
        margin-right: 16px;
      }
    }
  }
}
</style>

<style lang="scss">
.file {
  .tool-tip-content {
    text-align: center;
  }
  .file-item {
    .el-progress-bar__outer {
      height: 2px!important;
    }
  }
  .el-dialog__body {
    .el-textarea {
      &.renameErr {
        textarea {
          border: 1px solid #FF3939;
        }
      }
    }
    .err {
      display: flex;
      align-items: center;
      margin-top: 8px;
      font-size: 14px;
      color: #FF3939;
      i {
        font-size: 12px;
        margin: 0 8px;
      }
    }
  }
}
</style>
